import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import JobCard from '@Components/JobCard';
import dispatchRerender from 'dispatchRerender';
import SaveJobModal from '@Components/SaveJobModal';
import t from 'prop-types';
import { getFavorites } from 'anonFavJobs';
import getCallback from 'getCallback';
import { pushDataLayerRelatedJobs } from 'datalayer';
import getCountryName from 'getCountryName';
import textTransform from 'textTransform';

function RelatedJobs({ intl, searchParams, salary }) {
  const [relatedJobs, setRelatedJobs] = useState({});
  const [saveJobModal, setSaveJobModal] = useState(false);
  const renderSaveJobModal = process.env.REACT_APP_ENABLE_FAVORITE_JOBS === 'true';

  useEffect(() => {
    getCallback({
      callback: '@Callbacks/getRelatedJobs',
      currentRoute: {},
      locale: intl.locale,
      data: {
        occupation: searchParams.occupation,
        city: searchParams.city,
        region: searchParams.region,
        salary,
        defaultFavJobs: getFavorites(),
      },
    }).then((response) => {
      const relatedJobsData = response.data ? response.data : {};
      // Attach jobClick datalayer event and push related jobs event.
      if (relatedJobsData.jobsList.length > 0) {
        pushDataLayerRelatedJobs(relatedJobsData.jobsList);
      }
      setRelatedJobs(relatedJobsData);
      // Dispatch event for re-attaching orbit components.
      dispatchRerender();
      return relatedJobsData;
    }).catch(() => {
      setRelatedJobs({});
      return {};
    });
  }, [intl.locale, searchParams.city, searchParams.occupation, searchParams.region, salary]);

  const showSaveJobModal = (active) => setSaveJobModal(active);

  const closeJobModal = () => {
    showSaveJobModal(false);
    if (typeof window !== 'undefined') {
      document.querySelector('html').classList.remove('modal-open');
    }
  };

  return (
    <div data-testid="related-jobs">
      {relatedJobs.jobsList?.length
        ? (
          <section className={`block ${process.env.REACT_APP_COUNTRY === 'sph' ? 'bg-brand--light-grey' : 'bg-variant-brand-tertiary'}`}>
            <div className="block__wrapper block__wrapper--stacked wrapper">
              <div className="block__header block__header--split block__header--l">
                <h2 className="block__title">
                  {intl.formatMessage({ id: 'RelatedJobs.Title' }, {
                    occupation: textTransform(searchParams.occupation),
                    location: searchParams.city && searchParams.region ? textTransform(`${searchParams.city}, ${searchParams.region}`) : textTransform(getCountryName(intl.locale)),
                  })}
                </h2>
                <a href={relatedJobs.searchUrl} className="block__more-link">{intl.formatMessage({ id: 'RelatedJobs.ShowMore' })}</a>
              </div>
              <div className="block__content block__content--full-on-s block__content--full-on-m">
                <div className="cards">
                  <ul className="cards__list cards__list--format-carousel carousel--on-s carousel--on-m" data-rs-carousel="cards">
                    {relatedJobs.jobsList && relatedJobs.jobsList.map((job) => (
                      <JobCard
                        key={job.JobId}
                        jobData={job}
                        config={relatedJobs.config}
                        saveJobModalCb={showSaveJobModal}
                        favoriteJobs={relatedJobs.favoriteJobs}
                        jobListingsSettings={relatedJobs.jobListingsSettings}
                      />
                    ))}
                  </ul>
                  {
                    relatedJobs.jobsList && renderSaveJobModal
                      ? <SaveJobModal modalClose={closeJobModal} active={saveJobModal} /> : null
                  }
                </div>
              </div>
            </div>
          </section>
        ) : null}
    </div>
  );
}

RelatedJobs.propTypes = {
  searchParams: t.shape({
    occupation: t.string,
    region: t.string,
    city: t.string,
  }),
};

RelatedJobs.defaultProps = {
  searchParams: {
    occupation: '',
    region: '',
    city: '',
  },
};

export default injectIntl(RelatedJobs);
